import { actionCreatorFactory } from 'typescript-fsa';
import { QualityLevelInfo } from '../models/QualityState';

enum Type {
	SetAvailable = 'SET_QUALITY_AVAILABLE',
	SetLevels = 'SET_QUALITY_LEVELS',
	SetSelection = 'SET_QUALITY_SELECTION',
}

const create = actionCreatorFactory('QUALITY');

export const actionCreators = {
	setAvailable: create<boolean>(Type.SetAvailable),
	setLevels: create<QualityLevelInfo[]>(Type.SetLevels),
	setSelection: create<{ auto: boolean; currentLevel: number }>(Type.SetSelection),
};
